import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 120px);
  padding: 40px 20px;
  text-align: center;
`;

export const IconCircle = styled.div<{ $status: 'blocked' | 'cancelled' }>`
  width: 84px;
  height: 84px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  background-color: ${({ $status }) =>
    $status === 'blocked' ? 'rgba(239, 68, 68, 0.1)' : 'rgba(78, 93, 120, 0.1)'};
  color: ${({ $status }) =>
    $status === 'blocked' ? '#EF4444' : 'var(--fixit)'};
`;

export const PrincipalText = styled.h1`
  color: #1f2937;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 12px 0;
`;

export const SecondaryText = styled.p`
  color: #6b7280;
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
  max-width: 580px;
  margin: 0 0 28px 0;
`;

export const WhatsappSvg = styled.img`
  width: 10px;
  height: 10px;
`;
